import Point from "@/geom/Point"

var GeomUtils = {
    addPoints(point1, point2) {
        const x = point1.x + point2.x;
        const y = point1.y + point2.y;
        return new Point(x, y);
    }
}

export default GeomUtils;